module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enable":"Подключить","disable":"Отключить","connected":"Подключено","import":"Импортировать вакансии","importVacanciesFromHH":"Импортировать вакансии из HeadHunter","importVacanciesFromHHShort":"Импортировать вакансии из HH"}}')
  delete Component.options._Ctor
}
